export enum ModuleStatus {
  Initial = 'initial',
  Loaded = 'loaded',
}
